export default {"src":"/_next/static/media/fluicity.2db76eeb.svg","height":72,"width":320};